import React, {useState} from 'react';
import apiClient from '../../context/apiClient';
import {ReactComponent as CloudIcon} from '../../assets/icons/Cloud.svg';

const StundenkontingenteImport = () => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState(null);

    const handleFileChange = (e) => {
        const selected = e.target.files[0];
        setFile(selected);
        setError(null);
        setProgress(0);
    };

    const handleClearFile = () => {
        setFile(null);
        setProgress(0);
        setError(null);
    };

    const handleUploadAndDownload = async () => {
        if (!file) {
            setError('Bitte wählen Sie zuerst eine Datei aus.');
            return;
        }
        setUploading(true);
        setError(null);

        try {
            const formData = new FormData();
            formData.append('file', file);

            const res = await apiClient.post(
                '/api/employee/uploadStundenkontingenteFile',
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data'},
                    responseType: 'blob',
                    onUploadProgress: (e) => {
                        const percent = Math.round((e.loaded * 100) / e.total);
                        setProgress(percent);
                    }
                }
            );

            const url = window.URL.createObjectURL(new Blob([res.data]));
            const a = document.createElement('a');
            a.href = url;
            a.download = file.name.replace(/\.xlsx?$/, '') + '_ergebnis.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            const data = err.response?.data;
            if (data && typeof data === 'object' && !Array.isArray(data)) {
                const extracted = Object.entries(data).map(([f, m]) => `${f}: ${m}`);
                setError(extracted.join('\n'));
            } else {
                setError(Array.isArray(data) ? data.join('\n') : String(data || 'Upload/Download fehlgeschlagen'));
            }
        } finally {
            setUploading(false);
            setProgress(0);
        }
    };

    return (
        <main className="flex-1 h-full w-full flex flex-col">
            <div className="flex flex-1 gap-6 overflow-hidden">
                <div className="w-1/3 mx-auto h-full">
                    <div
                        className="bg-white shadow-md rounded-lg p-4 flex flex-col items-center text-center h-full justify-center">
                        <h3 className="text-lg font-semibold mb-2">Stundenkontingente hochladen</h3>
                        <p className="text-sm text-gray-600 mb-4">
                            Laden Sie eine Excel-Datei mit Stundenkontingenten hoch. Nach dem Upload wird automatisch
                            der
                            Download gestartet.
                        </p>
                        {/* Dropzone */}
                        <div
                            className="border-2 border-dashed border-teal-400 rounded-md p-6 w-full flex flex-col items-center text-center mb-4">
                            <CloudIcon className="h-10 w-10 text-teal-500 mb-3"/>
                            <p className="text-gray-700">
                                <span className="font-medium">Datei auswählen: </span>
                                <label className="text-teal-600 underline cursor-pointer">
                                    Durchsuchen
                                    <input type="file" accept=".xlsx, .xls" className="hidden"
                                           onChange={handleFileChange}/>
                                </label>
                            </p>
                            <p className="text-xs text-gray-500 mt-1">Nur Excel-Dateien (.xlsx, .xls)</p>
                        </div>

                        {/* Datei-Vorschau */}
                        {file && (
                            <div
                                className="flex items-center justify-between w-full border border-teal-300 rounded px-3 py-2 bg-gray-50 mb-4">
                                <div className="flex items-center space-x-2">
                                    <CloudIcon className="w-5 h-5 text-teal-500"/>
                                    <span className="text-sm text-gray-800 truncate max-w-[200px]">{file.name}</span>
                                </div>
                                <button onClick={handleClearFile}
                                        className="text-sm text-red-500 hover:underline ml-2">X
                                </button>
                            </div>
                        )}

                        {/* Fehleranzeige */}
                        {error && (
                            <div
                                className="bg-red-50 border border-red-300 text-red-700 p-4 rounded w-full shadow-sm mb-4">
                                {error.split('\n').map((line, i) => (
                                    <p key={i} className="text-sm">{line}</p>
                                ))}
                            </div>
                        )}

                        {/* Fortschritt */}
                        {uploading && (
                            <div className="w-full mb-4">
                                <div className="w-full bg-gray-200 rounded-full h-2">
                                    <div
                                        className="bg-teal-500 h-2 rounded-full transition-all duration-300"
                                        style={{width: `${progress}%`}}
                                    />
                                </div>
                            </div>
                        )}

                        {/* Upload/Download-Button */}
                        <button
                            onClick={handleUploadAndDownload}
                            disabled={!file || uploading}
                            className="w-full bg-teal-600 text-white py-2 rounded font-semibold hover:bg-teal-700 transition disabled:opacity-50"
                        >
                            {uploading ? 'Wird hochgeladen…' : 'Datei hochladen & herunterladen'}
                        </button>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default StundenkontingenteImport;
